<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Change Password</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{name: 'dashboard'}">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">Change Password</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content" >
      <div class="container-fluid">
      <div class="card">
        <div class="card-header">
          <!-- <a href="javascript:void(0)" class="btn btn-info" ><i class="fa fa-filter"></i>Filter</a> -->
          <div class="card-tools">
              <!-- <h5> CHANGE PASSWORD </h5> -->
            <!-- <router-link :to="{name: 'OpenTicket'}" class="btn btn-success">
              <i class="fas fa-plus"></i> Open Ticket
            </router-link>
            <button class="btn btn-info" @click="exportFile()">
              <i class="fas fa-download"></i> Export
            </button> -->
          </div>
        </div>

        <form @submit.prevent="OpenTicket" method="POST" novalidate>
          <div class="card-body">
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group form-row">
                  <label class="col-md-3 col-form-label" for="name">Current Password</label>
                  <div class="col-md-9">
                    <input type="text" class="form-control" id="name" v-model="fields.current_password" placeholder="Current Password">
                  </div>
                </div>

                <div class="form-group form-row">
                  <label class="col-md-3 col-form-label" for="name">New Password</label>
                  <div class="col-md-9">
                    <input type="text" class="form-control" id="name" v-model="fields.new_password" placeholder="New Password">
                  </div>
                </div>

                <div class="form-group form-row">
                  <label class="col-md-3 col-form-label" for="name">Retype Password</label>
                  <div class="col-md-9">
                    <input type="text" class="form-control" id="name" v-model="fields.retype_password" placeholder="Retype Password">
                  </div>
                </div>

                <!-- <div class="form-group form-row">
                  <label class="col-md-3 col-form-label" for="body">Body</label>
                  <div class="col-md-9">
                    <textarea  v-model="ticket.message" class="form-control" id="message" rows="8" cols="10"
                           placeholder="Write your message" ></textarea>
                  </div>
                </div> -->
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-9 offset-md-3">
                <button type="submit" class="btn btn-common m-2px">
                    <!-- <i class="fas fa-search"></i>  -->
                Submit</button>
                <!-- <button type="reset" class="btn btn-warning" @click="resetFilter()"><i class="fas fa-undo"></i> Reset</button> -->
              </div>
                </div>
              </div>
            </div>
            <br/>
            <div class="row text-left justify-content-start">
                <ul style="list-style-type: none; color: red">
                    <li >
                    * Password should be at least 6 digit and contain (0-9,a-z,A-Z,!,_,$)
                    </li>
                    <li >
                        * For changing password, you must have to change your Wi-Fi router settings (PPPoE Password) as well. Else you will face service interruption. For assistance you may call us at 09612363693 or email us at
                        <a href="mailto:info@carnival.com.bd">info@carnival.com.bd</a>
                    </li>
                </ul>
            </div>

          </div>
        </form>


        <div class="overlay" v-if="is_loading">
          <i class="fas fa-2x fa-sync-alt fa-spin"></i>
        </div>
        <!-- <div class="card-body p-0">
          <div class="p-4" v-if="_.isEmpty(list.data)">
            <div class="alert alert-default-warning" role="alert">
              No data found!
            </div>
          </div>
        </div> -->
        <div class="card-footer">
          <vue-pagination
            :pagination="list"
            v-if="list.total > list.per_page"
            @paginate="getUsageData()"
          />
        </div>
      </div>
      </div>
    </section>

    <section class="content" v-if="has_permission === false">
      <div class="alert alert-danger alert-dismissible">
        <h5><i class="icon fas fa-ban"></i> Permission denied!</h5>
      </div>
    </section>
  </div>
</template>

<script>

import VuePagination from "@/components/partials/PaginationComponent";
import SortIcons from "@/components/utils/SortIcons";
import axios from 'axios';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import {CommonAPI} from "@/services/api";
const fileDownload = require('js-file-download')
import { Notification } from "element-ui";

export default {
  name: 'DataUsage',
  metaInfo: {
    title: 'Ticket History | Dotlines'
  },
  components: {
    DatePicker,
    VuePagination,
    SortIcons
  },

  data: () => ({

    fields: {
        current_password: '',
        new_password: '',
        retype_password: ''

    },
    list: {
      total: 0,
      per_page: 3,
      from: 1,
      to: 0,
    },
    order_by: 'asc',
    api_url: '',
    showFilter: false,
    filter: {},
    dateRange: '',
    pre: [],
    is_loading: false,
    has_permission: true,
  }),
  // method is called after page load
  mounted: function () {

    // if (this.isMobile()) {
    //   window.$(document).find('.push-menu-class').trigger('click');
    // }

    // this.api_url = '/admin_users';
    // this.getUsageData();
    // // this.getOrganization();
    // this.$root.$on('sort-data', () => {
    //   this.$root.$emit('show-icon');
    //   this.getUsageData();
    // });
  },
  methods: {

    OpenTicket(){

        let _this = this;
        _this.$validator.validateAll().then((result) => {
            if(result){
                _this.is_loading = true;
                let api_url = "/open-ticket";
                let method = "POST";
                console.log(this.ticket);
                axios({
                method: method,
                url: api_url,
                data: _this.ticket,
                headers: { "Content-Type": "application/json" },
                })
                .then(function (response) {
                        _this.$toaster.success(response.data.message);
                        _this.is_loading = false;
                       // _this.$router.push({ name: "Users" });
                })
                .catch((errors) => {
                        //alert("Error happend!");
                       // console.log("Errors:::", errors);
                        //console.log("Errors:::", response);
                         console.log(errors.response.data);
                         _this.$setErrorsFromResponse(errors.response.data);
                        //   _this.$setErrorsFromResponse(errors.response.data.errors);
                })
                .finally(() => {
                      _this.is_loading = false;
                });
            }else{
                console.log("Validation failed");
            }
        });

    },

    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD hh:mm:ss');
    },

    getUsageData() {
    },

    getUsers(){

    },

    apiUsage(query = null) {
      return new Promise((resolve, reject) => {
        axios.get(this.api_url, {
          params: query
        }).then(response => {
          resolve(response.data);
        }).catch(error => {
          if (error.response.status === 403) {
            this.has_permission = false;
          }
          reject(error);
        })
      })
    }

  }
}
</script>

